var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 2H16.034C17.7142 2 18.5542 2 19.196 2.32698C19.7605 2.6146 20.2194 3.07354 20.507 3.63803C20.834 4.27976 20.834 5.11984 20.834 6.8V17.2C20.834 18.8802 20.834 19.7202 20.507 20.362C20.2194 20.9265 19.7605 21.3854 19.196 21.673C18.5542 22 17.7142 22 16.034 22H9.63398C7.95382 22 7.11374 22 6.47201 21.673C5.90752 21.3854 5.44858 20.9265 5.16096 20.362C4.83398 19.7202 4.83398 18.8802 4.83398 17.2V16.5M16.834 13H12.334M16.834 9H13.334M16.834 17H8.83398M6.83398 10V4.5C6.83398 3.67157 7.50555 3 8.33398 3C9.16241 3 9.83398 3.67157 9.83398 4.5V10C9.83398 11.6569 8.49083 13 6.83398 13C5.17713 13 3.83398 11.6569 3.83398 10V6",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocLink);
export default __webpack_public_path__ + "static/media/ic-doc-link.524809eb338d2d263cb6c5365af6e124.svg";
export { ForwardRef as ReactComponent };